<template>
  <div>
     <div class="payrollBox" style="position: relative;bottom:6px;" element-loading-custom-class="customClass" v-loading="loading">
       <div>
         <el-tabs v-model="tabIndex" type="card" style="height: calc(100vh - 80px)" >
           <el-tab-pane
             :key="item.name"
             v-for="(item, index) in dataList"
             :label="item.title"
             :name="'tab'+index"
           >
             <span slot="label">{{item.title}}<el-badge :value="item.num"></el-badge></span>
             <div style="height:calc(100vh - 185px);border: 1px salmon" class="gridContain">


               <vxe-grid
                 id="infoGroup"
                 border
                 show-footer
                 :optimization="{scrollX: {gt: 400}}"
                 :show-overflow="true"
                 :show-header-overflow="true"
                 :row-style="rowStyle"
                 keep-source
                 resizable
                 :loading="loading"
                 auto-resize
                 width="100%"
                 highlight-hover-row
                 height="100%"
                 ref="table"
                 :data="item.tableData"
                 :footer-method="footerMethod"
                 :custom-config="{storage: true}"
                 :tooltip-config="{enabled: true,theme:'light',contentMethod: showTooltipMethod}"
                 :edit-config="{trigger: 'click', mode: 'cell', showStatus: true,activeMethod: activeCellMethod}"
                 @edit-disabled="editActivedEvent"
                 @edit-closed="editClosedEvent">
                 <vxe-table-column type="selection" width="60" fixed="left" align="center"></vxe-table-column>
                 <vxe-table-column v-for="(column,i) in grounpColumns" :key='i'
                                   :type="column.type"
                                   width="120px"
                                   :title="column.title"
                                   align="center"
                                   :fixed="i<2?'left':''">
                   <template v-slot="{ row}">
                  <span>
                      <span>{{ row[column.field]}}</span>
                  </span>
                   </template>
                   <vxe-table-column v-for="(child,index) in column.listColumns" :key='index'
                                     :field="child.field" align="center" :title="child.title" :data-title="child.title"
                                     :visible="child.visible"
                                     width="120px"
                   >
                     <template v-slot="{ row}">
                       <span v-if="child.field==='deptId' && row[child.field]!=null">{{ row[child.field] | bspTableFilter({'1':'refs', '3':orgMap})}}</span>
                       <span v-if="child.field!='deptId'">{{ row[child.field] | bspTableFilter({'1':'dict', '2':dicts})}}</span>
                     </template>
                   </vxe-table-column>
                 </vxe-table-column>
                 <template v-slot:empty>
                    <span>
                      <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                            <use xlink:href="#icon-kong"></use>
                          </svg>
                      <p class="noData">暂无数据</p>
                    </span>
                 </template>
               </vxe-grid>




             </div>
           </el-tab-pane>

         </el-tabs>
       </div>

       <div  class="btnCon" style="position: absolute;top: 0;right: 0">
         <el-button style="background:rgba(64,158,255,1);color:rgba(255,255,255,1);" type="primary" size="small" @click="previewWage">预览工资单</el-button>
         <el-button style="background:rgba(64,158,255,1);color:rgba(255,255,255,1);" type="primary" size="small" @click="customerHeader">自定义表头</el-button>
         <el-button style="background:rgba(64,158,255,1);color:rgba(255,255,255,1);" type="primary" size="small" @click="exportTable">导出</el-button>
         <backBtn @reOnClick = "goback()" style="display: inline-block;margin-left: 10px;"></backBtn>
       </div>
     </div>
    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-loading="loading"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="showCustomerHeader"
    >
      <customHeader
        :headerType="headerType"
        :headerList.sync="headerList"
        :templateId="templateIdRoute"
        :batchId="batchIdRoute">

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="showCustomerHeader = false">
          取消
        </el-button>
      </div>
    </el-dialog>
    <!--预览工资单-->
    <el-dialog v-dialogDrag
               ref=""
               width="70%"
               id="PaySlip"

               :close-on-click-modal="true"
               :close-on-press-escape="true"
               title="工资条"
               :visible.sync="dialogpaySlipVisible"
    >
      <paySlipItem :itemLists="itemLists"></paySlipItem>
    </el-dialog>
  </div>
</template>

<script>
    import bspTable from "@/components/bsp/bsp-table/bsp-table";
    import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
    import { getListpage,updateListpage,addListpage,deleteData } from  "@/api/demo/demo"
    import {downloadBankPayFile,updataCustHeaderInfo} from  "@/api/wage/pay"
    import {queryBatchOnlyPayDetailPage} from "@/api/wage/batchTemplate";
    import exportMethod from "@/util/export"
    import { mapGetters } from 'vuex';
    import {downloadFile} from "@/util/util";
    import backBtn from '@/wage-components/back-btn/back-btn'
    import {exportExcleSheets} from "@/api/common/common"
    import customHeader from "@/views/wage/pay/customHeader/index";
    import paySlipItem from "@/views/wage/dataReadyTemplate/paySlipItem";
    import XEUtils from 'xe-utils';
    import {queryPayrollPreView} from '@/api/wage/pay'
    import {getCompanyOrg} from "@/api/org/org";
    import store from "@/store";
    import Moment from 'moment'

    export default {
        name: "table",
        components: {bspTableColumn, bspTable,backBtn,customHeader,paySlipItem},
        created(){
          this._getListpage()
          //调用方法获取组织机构
          this._getCompanyOrg(store.getters.cusId);
          // this.idcardList = this.dicts.codeList[1010]
        },
        mounted() {

        },
      computed: {
        ...mapGetters([
          'dicts',
        ]),
      },
        data(){
            return{
              itemLists: [],
              batchInfoDetail:this.$route.query.batchInfoDetail,//历史页面缓存数据
              formInline:this.$route.query.formInline,//历史页面缓存数据
              serverGroupList:this.$route.query.serverGroupList,//历史页面缓存数据
              contentServerGroup:this.$route.query.contentServerGroup,//历史页面缓存数据
              param: {
                empId: '',
                detailId: '',
                batchId: '',
              },
                hiddenColumns:[],
                orgMap:{},//组织结构map
                loading:false,
                dialogFormVisible: false,
                showTable: false,
                paySlipType:'',
                salaryDetailId:'',
                salaryDetail:'',
              dialogpaySlipVisible:false,
                list: [],
              sumListCode: [],//需要求合计的列
                idcardList: [],
                // parameter:{   //getDynamicForm参数
                //   batchId:this.$route.query.batchId,//页面跳转带回参数batchId
                //   payWay:this.$route.query.payWay//
                // },
                grounpColumns:[
                    {
                      field:"empName",
                      title:"员工姓名",
                    },
                    {
                      field:"empIdCard",
                      title:"雇员证件号码",
                      filters:[{data: ''}],
                      filterType:'datePicker',
                    }
                ],
                listQuery:{
                    page: 1,
                    limit: 20,
                    total:0,
                    batchId:this.$route.query.batchId,//页面跳转带回参数batchId
                    templateId:this.$route.query.templateId,//templateId
                },
                listForm: {},
                id:'',

                textMap: {
                    add: '新增',
                    update: '编辑'
                },
                dialogStatus: 'add',
                tabIndex:'tab0',
                showCustomerHeader:false,
                templateIdRoute:this.$route.query.templateId,
                batchIdRoute:this.$route.query.batchId,
                headerType:'1002',//仅工资条
                headerList:[],
                dataList:[],
                loading : false,

            }
        },
        methods: {
          rowStyle({ row, rowIndex }){
            var time = Moment(new Date()).format("YYYY-MM");

            for(let i=0;i<this.dataList.length;i++){
              if (this.dataList[i].tableData && this.dataList[i].tableData.length){
                for(let j=0;j<this.dataList[i].tableData.length;j++){
                  let Month = this.dataList[i].tableData[j].entryDate
                  //判断入职日期是否存在,存在进入
                  if(null != Month){
                    let neMonth = Month.substring(0,7)
                    let leaveMonth = this.dataList[i].tableData[j].leaveDate
                    //判断离职日期是否存在,
                    if(null != leaveMonth){
                      let neleaveMonth = leaveMonth.substring(0,7)
                      if(neleaveMonth == time){
                        return {
                          backgroundColor: '#f10a89',
                          color: '#181713'
                        }
                      }
                    }
                    if(neMonth == time){
                      return {
                        backgroundColor: '#0eefd5',
                        color: '#130d07'
                      }
                    }

                  }

                }
              }
            }


          },
          _getCompanyOrg(cusId){
            getCompanyOrg(cusId).then(res=>{
              let orgData = res.data;//查询机构树
              let map = {};
              for (let i = 0,l=orgData.length; i <l; i++) {
                map[orgData[i].id]=orgData[i].orgName;//id:orgName结构存储
              }
              this.orgMap =  map;
            })
          },
          //追加合计行：
          footerMethod({ columns, data }){
            this.hiddenColumns = [];
            return [
              columns.map((column, columnIndex) => {

                if(data&&data.length>0){
                  let columFiled = column.property;
                  let result = XEUtils.every(data,(data)=>{
                    return data[columFiled] ===0 || data[columFiled]===null
                      || data[columFiled] === '0'|| data[columFiled] === '0.0'|| data[columFiled] === '0.00'
                  })
                  if(result){
                    this.hiddenColumns.push(columFiled)
                  }
                }

                if (columnIndex === 2) {
                  return '合计'
                }
                if (this.sumListCode.includes(column.property)) {
                  return XEUtils.sum(data, column.property)
                }
                return null
              })
            ]
          },
            test(context){
                console.log(context)
                console.log(this.di)
            },
          getResult() {
            queryPayrollPreView(this.param).then(res => {
              let data=res.data
              if (data.msg==="success") {
                this.itemLists = data.data.dataList
                this.dialogpaySlipVisible = true;
              }else {
                this.$message.error("暂无数据");
              }
            })
          },
          previewWage(){
            console.log('预览工资单');
            const arr = this.$refs.table;
            console.log(arr[0].getCheckboxRecords());
            const arr2 = arr[0].getCheckboxRecords();
            if(arr2 &&arr2.length>0){
              if(arr2.length>1){
                this.$message.error("请选择一条薪资记录");
              }else{
                console.log(arr2[0]);
                this.param.empId = arr2[0].empId;
                this.param.detailId = arr2[0].id;
                this.param.batchId = arr2[0].batchId
                this.getResult();
              }
            }else{
              this.$message.error("至少选择一行数据");
            }
          },
            //获取列表数据
            _getListpage(){
              this.loading = true;
              var params = this.listQuery;
              params['headerType'] = this.headerType
              this.dataList = [];
              this.grounpColumns = [];
              queryBatchOnlyPayDetailPage(params).then(res => {

                this.loading = false;
                console.log(res.data)
                this.showTable = true
                //this.listQuery.total = res.data.total
                this.list = res.data.data[0]
                this.sumListCode = res.data.data[0].sumListCode
                this.dataList = res.data.data[0].dataList
                this.grounpColumns = res.data.data[0].grounpColumns
                console.log(this.grounpColumns);
                this.grounpColumns.splice(0, 0, {
                  title: '雇员姓名',
                  field: 'empName',
                  colIndex: 1,
                  width: 90,
                }, {
                  field: 'idCard',
                  title: '证件号码',
                  width: 150,
                });
              })
            },
            //新增表格
            showAddList(){
                // if(this.$refs['listForm']){
                //     this.$refs['listForm'].resetFields();
                // }
                this.listForm = {}
                this.dialogFormVisible = true
                this.dialogStatus='add'
            },
          downloadBankPayFile(){
            var params =this.listQuery;
            downloadBankPayFile(params).then(res=>{
              downloadFile(res);
              debugger
              if(res.status==200){
                this.$message.success("报盘文件下载成功！");
                //this.titileDetails()//刷新
              }else{
                this.$message.error("报盘文件下载失败！");
              }
            })
          },
            //展示编辑表单框
            showDialog(row){
                this.dialogFormVisible = true
                this.dialogStatus='update'
                this.listForm = row

            },
            //删除数据
            deleteRow(row){
                this.id = row.id;
                deleteData(this.id).then(res=>{
                  this.$message.success("删除成功")
                  this._getListpage();
                })
            },
            //导出表格
            exportTable(){
              exportExcleSheets(
                {
                  columns: [],
                  type: "excel",
                  beanName: "wageBatchDetailServiceImpl",
                  methodName: "findOnlyPayListMapByParams",
                  batchId: this.listQuery.batchId,
                  templateId:this.listQuery.templateId,
                  headerType:this.headerType,
                  isSort: true,
                  headerRowNum: 2,
                  fileName: "单工资条明细导出",
                  fileType: ".xls",
                },
                "/wage",true
              ).then(res => {
                downloadFile(res)
              })
            },
          //返回单工资条主页面
            goback(){
              this.$router.go(-1);//后退
              /*if(this.templateIdRoute && this.templateIdRoute=='111111'){
                let query = {
                  formInline:this.formInline,
                  batchInfoDetail:this.batchInfoDetail,
                  serverGroupList:this.serverGroupList,
                  contentServerGroup:this.contentServerGroup,
                }
                this.$router.push({ path: '/wage/data-ready-template',query});
              }else{
                this.$router.push({ path: '/payrollSettings/onePayHistory'});
              }*/
            },
            customerHeader(){
              this.showCustomerHeader = true;
            },
            saveCusHeader(){
              if(this.headerList&&this.headerList.length==0){
                this.$message.warning('请选择表头内容')
                return ;
              }
              console.log('保存传参',this.headerList)
              let param = {
                'batchId':this.batchIdRoute,
                'templateId':this.templateIdRoute,
                'headers':this.headerList,
                'headerType':this.headerType  //仅工资条
              }
              this.loading = true;
              updataCustHeaderInfo(param).then(res=>{
                this.loading = false;
                if(res.data.code==0){
                  //刷新页面
                  this._getListpage();

                  //关闭自定义页面
                  this.showCustomerHeader = false;
                  this.$message.success('自定义保存成功!');
                }else{
                  this.$message.warning(res.data.msg);
                }
              });
            },
        }
    }
</script>

<style scoped>

  .gridContain >>> .vxe-body--row .vxe-cell {
    height: 100%;
    padding: 0;
    line-height: 46px;
  }

  .gridContain >>> .vxe-body--row .vxe-cell .copyMsg {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(252, 229, 229, 1);
  }

  .gridContain >>> .vxe-body--row .vxe-cell .updateMsg, .gridContain >>> .vxe-body--row .col--dirty .copyMsg {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(253, 242, 184, 1);
  }
  .payrollBox>>>.el-tabs__nav-wrap{
    width: calc(100% - 600px);
  }
</style>
